import { CryptoEventViewModel, CryptoGuess } from "@/event-core/types";
import { useEffect, useMemo, useState } from "react";

export function useSelectedGuess(
    guessList: CryptoEventViewModel["guessList"],
    guessDetail?: CryptoGuess,
    initialGuessNo?: string,
) {
    const defaultGuess = useMemo( () => {
        if ( guessDetail?.guessNo ) {
            return guessDetail;
        }
        if ( initialGuessNo ) {
            return guessList.find( ( g ) => g.guessNo === initialGuessNo )
                || guessList.find( ( g ) => g.mainFlag === 1 )
                || guessList[0]
                || {};
        }
        return guessList.find( ( g ) => g.mainFlag === 1 ) || guessList[0] || {};
    }, [ guessList, guessDetail, initialGuessNo ] );

    const [ selectedGuessNo, setSelectedGuessNo ] = useState( initialGuessNo || defaultGuess.guessNo || "" );
    const [ externalGuess, setExternalGuess ] = useState<CryptoGuess | null>( null );

    useEffect( () => {
        if ( guessDetail?.guessNo ) {
            setSelectedGuessNo( guessDetail.guessNo );
        }
    }, [ guessDetail?.guessNo ] );

    useEffect( () => {
        if ( !guessDetail?.guessNo && initialGuessNo ) {
            setSelectedGuessNo( initialGuessNo );
            setExternalGuess( null );
        }
    }, [ guessDetail?.guessNo, initialGuessNo ] );

    const selectGuess = useMemo( () => {
        if ( externalGuess && externalGuess.guessNo === selectedGuessNo ) {
            return externalGuess;
        }
        const newGuess = guessList.find( ( g ) => g.guessNo === selectedGuessNo ) || defaultGuess;

        return newGuess;
    }, [ guessList, selectedGuessNo, defaultGuess, externalGuess ] );

    const setSelectedGuess = ( guessOrGuessNo: string | CryptoGuess ) => {
        if ( typeof guessOrGuessNo === "string" ) {
            setSelectedGuessNo( guessOrGuessNo );
            setExternalGuess( null );
        } else {
            setSelectedGuessNo( guessOrGuessNo.guessNo || "" );
            setExternalGuess( guessOrGuessNo );
        }
    };

    return {
        selectedGuessNo,
        selectGuess,
        setSelectedGuessNo: setSelectedGuess,
    };
}
